export const bongersABI = ["function mint(uint256 quantity) external payable"]
